import React from "react";
import Navbar from "./Navbar";
import NotificationsIcon from "@mui/icons-material/Notifications";
import SettingsIcon from "@mui/icons-material/Settings";
import { NavLink, Outlet } from "react-router-dom";
import "./layout.scss";
function Layouts({ routes }: any) {
  return (
    <div className="layout">
      <input type="checkbox" style={{ display: "none" }} id="humberIcon" />
      <label className="mobile_open" htmlFor="humberIcon"></label>
      <div className="sidebar">
        <div className="sidebarlogo">
          <img src="../../../logo.png" alt="" />
        </div>
        <div className="sidenav_container">
          <ul>
            {routes?.map((item: any, i: number) => (
              <li className="nodrop" key={i}>
                <NavLink
                  to={item?.PATH}
                  className={({ isActive }) =>
                    isActive ? "nav_link nav_link_active" : "nav_link"
                  }
                >
                  <div className="nav_item">
                    {item?.ICON && <item.ICON />}
                    <div className="tile">{item?.TITLE}</div>
                  </div>
                </NavLink>
              </li>
            ))}
          </ul>
        </div>
      </div>
      <div className="main_container">
        <Navbar>
          <NotificationsIcon />
          <SettingsIcon />
          <div className="admin_menu">
            <div className="avatar">
              <img src="../../../avatar.png" alt="" />
            </div>
            <div className="dropdown">
              <div className="dropdown_content">
                <p
                  className="logout_text"
                  onClick={() => {
                    localStorage.clear();
                    window.location.href = "/login";
                  }}
                >
                  Logout
                </p>
              </div>
            </div>
          </div>
        </Navbar>
        <div className="container_main">
          <Outlet />
        </div>
      </div>
    </div>
  );
}

export default Layouts;
